import { useState, useEffect } from "react"
import { isEmpty, startCase, toLower } from "lodash"
import * as qs from "query-string"

// export const mail_form_url = `${process.env.GATSBY_CLOUD_URL}/api/form`;
export const mail_form_url = "/api/gatsby-theme-starberry-lomondgroup/form"
export const send_friend_mail_form_url =
  "/api/gatsby-theme-starberry-lomondgroup/send-to-friend-property-form"
export const payment_form_url =
  "/api/gatsby-theme-starberry-lomondgroup/payment-form"
export const rent_form_url = "/api/gatsby-theme-starberry-lomondgroup/rent-form"
export const rent_form_url_linley =
  "/api/gatsby-theme-starberry-lomondgroup/rent-form-linley"
export const rent_form_url_bv =
  "/api/gatsby-theme-starberry-lomondgroup/rent-form-brandvaughan"
export const rent_form_url_bvstudents =
  "/api/gatsby-theme-starberry-lomondgroup/rent-form-bvstudents"

export const Mail_Function = (formvalues) => {
  window.fetch(`${mail_form_url}`, {
    method: "POST",
    mode: "no-cors",
    headers: {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: qs.stringify(formvalues),
  })
}

export const Rent_Mail_Function = (formvalues) => {
  window.fetch(`${rent_form_url}`, {
    method: "POST",
    mode: "no-cors",
    headers: {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: qs.stringify(formvalues),
  })
}

export const Rent_Mail_Function_Linley = (formvalues) => {
  window.fetch(`${rent_form_url_linley}`, {
    method: "POST",
    mode: "no-cors",
    headers: {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: qs.stringify(formvalues),
  })
}

export const Rent_Mail_Function_BV = (formvalues) => {
  window.fetch(`${rent_form_url_bv}`, {
    method: "POST",
    mode: "no-cors",
    headers: {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: qs.stringify(formvalues),
  })
}

export const Rent_Mail_Function_BVStudents = (formvalues) => {
  window.fetch(`${rent_form_url_bvstudents}`, {
    method: "POST",
    mode: "no-cors",
    headers: {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: qs.stringify(formvalues),
  })
}

export const SendFriend_Mail = (formvalues) => {
  window.fetch(`${send_friend_mail_form_url}`, {
    method: "POST",
    mode: "no-cors",
    headers: {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: qs.stringify(formvalues),
  })
}

export const Payment_Mail = (formvalues) => {
  window.fetch(`${payment_form_url}`, {
    method: "POST",
    mode: "no-cors",
    headers: {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: qs.stringify(formvalues),
  })
}

export const uniqueID = () => {
  let text = ""
  const possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789"

  for (let i = 0; i < 20; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length))
  }
  return text
}

export const externalURL = (link) => {
  if (link.indexOf("http://") === 0 || link.indexOf("https://") === 0) {
    return true
  }

  return false
}

/** Add scripts tag */
export const AppendScript = (url, id, callback) => {
  if (document.getElementById(id) === null) {
    const e = document.createElement("script")
    e.src = url
    e.id = id
    e.async = true
    e.defer = true
    e.type = "text/javascript"
    e.addEventListener("load", callback(true))
    document.getElementsByTagName("body")[0].appendChild(e)
  } else {
    callback(false)
  }
}
/** Start with */
export const startsWith = (str, word) => {
  return str?.lastIndexOf(word, 0) === 0
}

/** Eng with */
export const endsWith = (str, word) => {
  return str?.slice(-1) === word
}

/** Get number only */
export const filterNumber = (str) => {
  if (!str) return 0
  const str_val = str.toString()
  return parseInt(str_val.replace(/[^\d.]/g, ""), 10)
}

/** currency format conversion */
export const currencyFormat = (num, currency = "£", withSpace = false) => {
  const filterNum = filterNumber(num)
  if (!filterNum) {
    return `${currency} 0`
  }
  if (withSpace) {
    return `${currency} ${new Intl.NumberFormat("en-US", {}).format(filterNum)}`
  }
  return `${currency}${new Intl.NumberFormat("en-US", {}).format(filterNum)}`
}

/** Get number format with out currency */
export const numberFormat = (num) => {
  if (!num) return 0
  return new Intl.NumberFormat("en-US", {}).format(num)
}

/** Get url params */
export const getUrlParams = () => {
  const urlSearchParams = new URLSearchParams(window.location.search)
  return Object.fromEntries(urlSearchParams.entries())
}

/** string include spl character */
export const isIncludeSplChar = (text) => {
  // const format = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/
  const format = /[`!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/
  return format.test(text)
}
/** string to captilize */
export const toCapitalize = (str) => {
  if (!isEmpty(str)) {
    return startCase(
      toLower(str.replace(/[^a-zA-Z0-9]/g, " ").replace(/\s+/g, " ")),
    )
  }
  return str
}

/** string remove all special characters */
export const removeSpecialChar = (val, symbol = "-") => {
  if (!isEmpty(val)) {
    return val
      .replace(/[^\w\s]/gi, " ")
      .replace(/\s\s+/g, " ")
      .replace(/ /gi, symbol)
      .toLowerCase()
  }
  return val
}

/** Get url params */
export const squareFeetToMeter = (val) => {
  const meter = 0.09290304 * val
  return `${Math.round(meter)}`
}

export const isNotEmpty = (val) => {
  if (typeof val !== "undefined" && val !== null && val !== "") {
    return true
  }
  return false
}

/** GTM Event Trigger */
export const gtmEvent = ({ formType, formName }) => {
  if (typeof window !== "undefined") {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: "formSubmit",
      formType: `form-${formType}`,
      formId: `form-${formType}`,
      formName,
      formLabel: formName,
    })
  }
}

export const addCommas = (num) =>
  num ? num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : ""

export const removeNonNumeric = (num) =>
  num ? num.toString().replace(/[^0-9]+/g, "") : ""

export const numericWithDecimal = (num) =>
  // num ? num.toString().replace(/[^0-9\.]+/g, "") : ""
  num ? num.toString().replace(/[^0-9.]+/g, "") : ""

export const getPriceStr = (min, max) => {
  let priceStr = ""
  if (min && max) {
    priceStr = `between ${currencyFormat(min)} and ${currencyFormat(max)}`
  } else if (max) {
    priceStr = `under ${currencyFormat(max)}`
  } else if (min) {
    priceStr = `above ${currencyFormat(min)}`
  }
  return priceStr
}

const getWindowDimensions = () => {
  const { innerWidth: width, innerHeight: height } = window
  return {
    width,
    height,
  }
}

export const useWindowDimensions = () => {
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions(),
  )

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions())
    }

    window.addEventListener("resize", handleResize)
    return () => window.removeEventListener("resize", handleResize)
  }, [])

  return windowDimensions
}

export const subtractYears = (date, years) => {
  date.setFullYear(date.getFullYear() - years)

  return date
}

export const getDateFormat = (date) => {
  const yyyy = date.getFullYear()
  let mm = parseInt(date.getMonth() + 1, 10)
  let dd = date.getDate()

  if (dd < 10) {
    dd = `0${dd}`
  }
  if (mm < 10) {
    mm = `0${mm}`
  }

  const dateFormat = `${yyyy}-${mm}-${dd}`

  return dateFormat
}

export const subtractDate = (date, subval) => {
  const subDate = date.setDate(date.getDate() - subval)
  const dateFormat = getDateFormat(new Date(subDate))

  return dateFormat
}

export const removeTags = (str) => {
  if (str === null || str === "") return false
  // eslint-disable-next-line no-param-reassign
  str = str.toString()

  // Regular expression to identify HTML tags in
  // the input string. Replacing the identified
  // HTML tag with a null string.
  return str.replace(/(<([^>]+)>)/gi, "")
}
